"use strict";

exports.__esModule = true;
exports["default"] = Rss;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Rss(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M138.035 442.724c0 37.398-30.351 67.705-67.75 67.705-37.378 0-67.686-30.307-67.686-67.705 0-37.4 30.308-67.729 67.686-67.729 37.4-.001 67.75 30.328 67.75 67.729zM2.641 272.04c63.465 0 123.068 24.801 167.918 69.819 44.892 45.102 69.628 105.168 69.628 169.035h97.718c0-185.626-150.377-336.595-335.264-336.595v97.741zm.191-173.3c226.063 0 410 184.972 410 412.26h97.762c0-281.234-227.772-510-507.762-510v97.74z"
  }));
}